/**
 * Created by sange on 15/08/2017.
 */

import * as Auth from '../actions'

import { LoggedVendorUserV1 } from '../../../../api/api/models/logged-vendor-user-v1'

export interface State {
  user: LoggedVendorUserV1 | null
}

export const initialState: State = {
  user: null,
}

export function reducer(state = initialState, action: Auth.AuthActions | Auth.UserActions): State {
  switch (action.type) {

    case Auth.ME: {
      return {
        ...state,
        user: action.payload.user
      } as State
    }

    case Auth.LOGOUT_SUCCESS: {
      return {...initialState} as State
    }

    case Auth.UPLOAD_IMAGE_SUCCESS: {
      const {imgUrl} = action.payload
      return {
        ...state,
        user: {...state.user, imgUrl}
      } as State
    }

    case Auth.SAVE_PROFILE_SUCCESS: {
      const {user} = action.payload
      return {
        ...state,
        user: {...state.user, ...user}
      } as State
    }

    default: {
      return state
    }
  }
}

export const getUser = (state: State) => state.user



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/reducers/user.reducer.ts